module.exports = __webpack_public_path__ + "media/images/dice-on-blue-ef5a017980017a63c415e5259ef6d0a2.jpg";